import React from 'react';

import Plan from './plan/Plan';
import { Anchor, SectionHeader, Spacer } from '@/components/common';

import './Pricing.css';

interface PricingProps {
  showHeader?: boolean;
  header?: string;
}

const Pricing: React.FC<PricingProps> = ({
  showHeader = true,
  header = 'Pricing'
}) => {
  const plans = [
    {
      title: 'Solo',
      description: 'For clinics with 1-2 dentists',
      originalPrice: 1299,
      price: 399,
      discountPercentage: 70,
      isPopular: false
    },
    {
      title: 'Team',
      description: 'For clinics with 3-6 dentists',
      originalPrice: 2499,
      price: 1299,
      discountPercentage: 50,
      isPopular: true
    },
    {
      title: 'Enterprise',
      description: 'For clinics with 7+ dentists',
      originalPrice: 3299,
      price: 1799,
      discountPercentage: 50,
      isPopular: false
    }
  ];

  return (
    <div className="pricing">
      <Anchor id="to-pricing" />
      {showHeader && <SectionHeader>{header}</SectionHeader>}
      <Spacer top={16} />
      <div className="pricing__plans-container">
        {plans.map((plan, index) => (
          <Plan
            key={index}
            title={plan.title}
            description={plan.description}
            originalPrice={plan.originalPrice}
            price={plan.price}
            discountPercentage={plan.discountPercentage}
            isPopular={plan.isPopular}
          />
        ))}
      </div>
    </div>
  );
};

export default Pricing;
